const getDeedPathSlugFromType = (type: string): string => {
  switch (type) {
    case 'Campaign':
      return 'campaigns';

    case 'Project':
      return 'projects';

    case 'Event':
      return 'volunteer';

    case 'BaseEvent':
      return 'events';

    default:
      return 'volunteer';
  }
};

export default getDeedPathSlugFromType;
